// ─────────────────────────────────────────────────────────────────────────────
// 🚨 THE STEP LIST THE SHELL RENDERS. MIRRORED FROM THE BACKEND CONSTANT.
//
// backend/constants/guidedFlow.js is the authority; the frontend cannot import
// from backend/, so this exists twice by necessity and
// backend/test/guidedFlowShell.test.js fails if the two disagree — the same
// arrangement ASSET_DOC_TYPES and the self-employed rule use, for the same
// reason.
//
// 🔑 consent: true SUPPRESSES EVA, AND IT IS A PROPERTY OF THE SCREEN. A list of
// step numbers held in the shell would be correct until somebody inserted a
// step, at which point Eva would appear beside an attestation and nothing would
// fail. Declared here, a new consent screen that forgets the flag is caught by a
// test instead of by a borrower.
//
// ⚠️ NO BORROWER-FACING STRING HERE MAY SAY "ReadyCheck". The labels are what
// the progress bar prints; the word is internal and a test scans for it.
// ─────────────────────────────────────────────────────────────────────────────
export const GUIDED_STEPS = [
  { n: 1, key: 'about_you', label: 'About you', surface: 'application', part: 1 },
  { n: 2, key: 'property_and_funds', label: 'Property and funds', surface: 'application', part: 2 },
  { n: 3, key: 'certify', label: 'Review and certify', surface: 'application', part: 3, consent: true },
  { n: 4, key: 'identity', label: 'Verify your identity', consent: true },
  // 🔑 NO LONGER A PLACEHOLDER — phase 4 built it (GuidedDocumentsStep).
  { n: 5, key: 'documents', label: 'Income, assets and housing' },   // renamed (Jesse, 2026-10-22)
  // 🔑 BUILT IN PHASE 5 (GuidedVerifiedStep, GuidedCreditStep).
  { n: 6, key: 'verified', label: 'Confirm income and assets' },   // renamed (Jesse, 2026-10-26: the self-driven flow — nothing is staff-verified here)
  { n: 7, key: 'credit', label: 'Credit authorization', consent: true },
  // 🔑 BUILT IN PHASE 6 (GuidedDecisionStep).
  { n: 8, key: 'decision', label: 'Your decision' },
];

export const TOTAL_STEPS = GUIDED_STEPS.length;

export const stepByNumber = (n) => GUIDED_STEPS.find((s) => s.n === Number(n)) || null;

/** Eva renders unless the step declares a consent. */
export const evaAllowedOn = (n) => {
  const s = stepByNumber(n);
  return !!s && !s.consent;
};
